import { BorderRadius, ButtonSize, Color, sizeToDimension, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const RecurringInvoiceSettingsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
  min-height: 100px;
  margin: ${Spacing.S16} 0;
  padding: ${Spacing.S16} ${Spacing.S16} ${Spacing.S10} ${Spacing.S16};
  border: 0px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R12};
  background: ${Color.Grey100};
`

interface RecurringInvoiceSettingsFooterProps {
  buttonSize: ButtonSize
}

export const RecurringInvoiceSettingsFooter = styled.div<RecurringInvoiceSettingsFooterProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ buttonSize }) => `${sizeToDimension[buttonSize]}px`};
`
